export const GUIDES = [
  {
    slug: "blueprint",
    title: "The Bermuda Vacation Rental Blueprint",
    series: "The Flagship Guide",
    collection: "owner",
    pages: 28,
    price: 30,
    cover: "/guides/cover-blueprint.jpg",
    pdf: "/bermuda-vacation-rental-blueprint.pdf",
    description: "From empty property to 5-star guest experience — the complete launch playbook: positioning, preparation, design, publishing and operations.",
  },
  {
    slug: "cleaning-turnover-manual",
    title: "The Bermuda Host's Cleaning & Turnover Manual",
    series: "The Bermuda Owner Series",
    collection: "owner",
    pages: 14,
    price: 20,
    cover: "/guides/cover-cleaning-turnover-manual.jpg",
    pdf: "/bermuda-hosts-cleaning-turnover-manual.pdf",
    description: "A fillable operating manual for consistent cleaning, inspection, restocking and maintenance handoff — turnover after turnover.",
  },
  {
    slug: "design-guide",
    title: "The Bermuda Vacation Rental Design Guide",
    series: "The Bermuda Owner Series",
    collection: "owner",
    pages: 14,
    price: 20,
    cover: "/guides/cover-design-guide.jpg",
    pdf: "/bermuda-vacation-rental-design-guide.pdf",
    description: "A practical design workbook for a calm, durable and distinctly Bermuda guest experience — room by room.",
  },
  {
    slug: "five-star-guest-experience",
    title: "How to Create a 5-Star Bermuda Guest Experience",
    series: "The Bermuda Owner Series",
    collection: "owner",
    pages: 14,
    price: 20,
    cover: "/guides/cover-5-star-guest-experience.jpg",
    pdf: "/5-star-bermuda-guest-experience.pdf",
    description: "A fillable service journey from booking confirmation to the review that follows — hospitality as a system, not a hope.",
  },
  {
    slug: "guest-guide",
    title: "The Bermuda Co-Host Guest Guide",
    series: "The Bermuda Guest Series",
    collection: "guest",
    pages: 16,
    price: 20,
    cover: "/guides/cover-guest-guide.jpg",
    pdf: "/bermuda-guest-guide.pdf",
    description: "The complete fillable stay planner for guests arriving by plane — trip details, guest list, flexible itineraries and island know-how.",
  },
  {
    slug: "couples-guide",
    title: "Bermuda Couples Guide",
    series: "The Bermuda Guest Series",
    collection: "guest",
    pages: 16,
    price: 20,
    cover: "/guides/cover-couples-guide.jpg",
    pdf: "/bermuda-couples-guide.pdf",
    description: "Your romantic escape planner — date nights, sunset spots, celebrations and quiet corners, fillable for two.",
  },
  {
    slug: "kids-guide",
    title: "Bermuda With Kids Guide",
    series: "The Bermuda Guest Series",
    collection: "guest",
    pages: 16,
    price: 20,
    cover: "/guides/cover-kids-guide.jpg",
    pdf: "/bermuda-with-kids-guide.pdf",
    description: "The family-friendly planner — age-aware activities, beach days, rainy-day backups and space for every child's list.",
  },
  {
    slug: "luxury-guide",
    title: "Luxury Bermuda Guide",
    series: "The Bermuda Guest Series",
    collection: "guest",
    pages: 16,
    price: 20,
    cover: "/guides/cover-luxury-guide.jpg",
    pdf: "/luxury-bermuda-guide.pdf",
    description: "Your elevated Bermuda experience planner — charters, fine dining, spa days and curated island moments.",
  },
  {
    slug: "cruise-guide",
    title: "Bermuda Cruise Ship Guide",
    series: "The Bermuda Guest Series",
    collection: "guest",
    pages: 16,
    price: 20,
    cover: "/guides/cover-cruise-guide.jpg",
    pdf: "/bermuda-cruise-ship-guide.pdf",
    description: "The port-day planner for cruise guests — dock details, timed itineraries and all-aboard planning, never miss the ship.",
  },
];

export const OWNER_SERIES_BUNDLE = {
  slug: "owner-series-bundle",
  title: "The Complete Owner Series",
  price: 79,
  worth: 90,
  pages: 70,
};
